// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O_HzN","label":"styles_label__3GwEi"};